import { authenticatedAxios } from "lib/actions/fetcher";
import { endpointsMembers } from "lib/actions/endpoints/endpointsMembers";
import { ProjectMemberPermissions } from "lib/types/members/ProjectMemberPermissions";

export function setProjectMemberPermissions(
  projectId: number,
  userId: string,
  permissions: ProjectMemberPermissions,
) {
  return authenticatedAxios.request<void>({
    ...endpointsMembers.projectPermissions(projectId, userId),
    data: permissions,
    headers: { "Content-Type": "application/json" },
  });
}
